import { Button, Row, Col } from "react-bootstrap";
import { OpenForSubmissionOptions } from "../../../../api/LicenceDetails";
import {
  GetMakeAnObjectionUrl,
  GetSubmissionUrl,
} from "../../../../external-apps/Config";
import { ILicenceDetailsProps } from "./ILicenceDatailsProps";

export const MakeSubmissionOrObjection = ({
  licence,
  licenceProfile,
}: ILicenceDetailsProps) => {
  const submissionUrl = GetSubmissionUrl(licence.regno);
  const objectionsUrl = GetMakeAnObjectionUrl(licence.regno);
  return (
    <div>
      <Row>
        <Col className="col-12 col-md-12">
          {licence.openforsubmissions ===
            OpenForSubmissionOptions.OpenForSubmissions && (
            <>
              <Button href={submissionUrl} target="_blank">
                {"Make a Submission"}
              </Button>

              <span className="ms-2 text-dark fw-bold">
                {licence.dateclosedforsubmissions == null ||
                licence.dateclosedforsubmissions === "-"
                  ? "Submissions close on issue of PD"
                  : `Submissions close on ${licence.dateclosedforsubmissions}`}
              </span>
            </>
          )}
          {licence.openforsubmissions ===
            OpenForSubmissionOptions.OpenForObjections && (
            <Button href={objectionsUrl} target="_blank">
              {"Make an Objection"}
            </Button>
          )}
        </Col>
      </Row>
    </div>
  );
};
